import React from 'react';
import { Jumbotron } from 'reactstrap';
import styled from 'styled-components';
import { textMuted } from '../modules/Styles';
var MissingNotice = styled(function (_ref) {
  var className = _ref.className,
      children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/React.createElement(Jumbotron, {
    className: className
  }, /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("div", null, children));
}).withConfig({
  displayName: "MissingNotice",
  componentId: "sc-1favsbt-0"
})(["", " > h2{font-weight:bold;}> div{p{font-size:21px;}}"], textMuted());
export default MissingNotice;